module.exports = __webpack_public_path__ + "img/5.9d907489.jpg";